import {
    createRouter,
    createWebHistory
} from 'vue-router'

// 导入页面组件
import Login from '../views/login.vue'
import Callback from '../views/callback.vue'
import Workbench from '../views/Workbench.vue'
import Customer from '../views/Customer.vue'
import Live from '../views/Live.vue'
import Myindex from '../views/myindex.vue'
import InviteCustomers from '../views/Invitecustomers/Invitecustomers.vue'
import WriteOff from '../views/write-off/write-off.vue'
import WriteOffOrder from '../views/write-off/write-off-order.vue'
import OrderWrite from '../views/write-off/orderwrite.vue'
import WriteOffCoupon from '../views/write-off/write-off-coupon.vue'
import ShopCheckIn from '../views/shopcheckin/shopcheckin.vue'
import CheckInStatus from '../views/shopcheckin/checkinstatus.vue'
import OrderList from '../views/orderlist/orderlist.vue'
import OrderDetails from '../views/orderlist/orderdetails.vue'
import MyDepartments from '../views/myDepartments/myDepartments.vue'
import CustomerBirthday from '../views/operation/CustomerBirthday.vue'
import StoreCart from '../views/store_view/store_cart.vue'
import StoreOrder from '../views/store_view/store_order.vue'
import StoreShopList from '../views/store_view/store_shop_list.vue'
import StoreConfirm from '../views/store_view/store_confirm.vue'
import StoreOrderDetail from '../views/store_view/store_order_detail.vue'
// 定义路由规则
const routes = [{
        path: '/',
        redirect: '/workbench'
    },
    {
        path: '/login',
        name: 'login',
        title: '登录',
        component: Login
    },
    {
        path: '/callback',
        name: 'callback',
        title: '登录回调',
        component: Callback
    },
    {
        path: '/workbench',
        name: 'workbench',
        title: '工作台',
        component: Workbench
    },

    // 我的客户
    {
        path: '/customer',
        name: 'customer',
        title: '客户',
        component: Customer
    },
    {
        path: '/customerList',
        name: 'customerList',
        title: '我的客户',
        component: () => import("@/views/customer/customerList.vue")
    },
    {
        path: '/customerDetail',
        name: 'customerDetail',
        title: '客户详情',
        component: () => import("@/views/customer/customerDetail.vue")
    },
    // 直播相关
    {
        path: '/live',
        name: 'live',
        title: '直播',
        component: Live
    },
    {
        path: '/liveDetail',
        name: 'liveDetail',
        title: '直播详情',
        component: () => import("@/views/live/liveDetail/index.vue")
    },
    // 活动
    {
        path: '/activity',
        name: 'activity',
        title: '活动',
        component: () => import("@/views/activity/activity.vue")
    },
    {
        path: '/activityAdd',
        name: 'activityAdd',
        title: '创建活动',
        component: () => import("@/views/activity/activityAdd.vue")
    },
    {
        path: '/activityCoupon',
        name: 'activityCoupon',
        title: '优惠券',
        component: () => import("@/views/activity/activityCoupon.vue")
    },
    // 我的团队
    {
        path: '/myTeam',
        name: 'myTeam',
        title: '我的团队',
        component: () => import("@/views/myTeam/myTeam.vue")
    },
    {
        path: '/teamMember',
        name: 'teamMember',
        title: '成员管理',
        component: () => import("@/views/myTeam/teamMember.vue")
    },
    // 客户转移
    {
        path: '/transformCustomer',
        name: 'transformCustomer',
        title: '客户转移',
        component: () => import("@/views/transformCustomer/transformCustomer.vue")
    },
    {
        path: '/selectManager',
        name: 'selectManager',
        title: '选负责人',
        component: () => import("@/views/transformCustomer/selectManager.vue")
    },

    {
        path: '/myindex',
        name: 'myindex',
        title: '我的',
        component: Myindex
    },
    {
        path: '/invite-customers',
        name: 'invite-customers',
        title: '邀请客户',
        component: InviteCustomers
    },
    {
        path: '/write-off',
        name: 'write-off',
        title: '核销',
        component: WriteOff
    },
    {
        path: '/write-off-order',
        name: 'write-off-order',
        title: '核销订单提货',
        component: WriteOffOrder
    },
    {
        path: '/orderwrite',
        name: 'orderwrite',
        title: '核销订单',
        component: OrderWrite
    },
    {
        path: '/write-off-coupon',
        name: 'write-off-coupon',
        title: '核销优惠券',
        component: WriteOffCoupon
    },
    {
        path: '/shopcheckin',
        name: 'shopcheckin',
        title: '门店签到',
        component: ShopCheckIn
    },
    {
        path: '/checkinstatus',
        name: 'checkinstatus',
        title: '签到状态',
        component: CheckInStatus
    },
    {
        path: '/orderlist',
        name: 'orderlist',
        title: '订单列表',
        component: OrderList
    },
    {
        path: '/orderdetails',
        name: 'orderdetails',
        title: '订单详情',
        component: OrderDetails
    },
    {
        path: '/myDepartments',
        name: 'myDepartments',
        title: '我的部门',
        component: MyDepartments
    },
    {
        path: '/customer-birthday',
        name: 'customer-birthday',
        title: '客户生日',
        component: CustomerBirthday
    },
  {
    path: '/store_cart',
    name: '门店购物车',
    component: StoreCart
  },
  {
    path: '/store_order',
    name: '门店订单',
    component: StoreOrder
  },
  {
    path: '/store_shop_list',
    name: '门店进货',
    component: StoreShopList
  },
  {
    path: '/store_confirm',
    name: '门店订单确认',
    component: StoreConfirm
  },
  {
    path:'/store_order_detail',
    name:'进货订单详情',
    component:StoreOrderDetail
  },
    //  代客下单
    {
        path: '/BuyerProxyPayment',
        name: 'BuyerProxyPayment',
        title: '代客下单',
        component: () => import("@/views/BuyerProxyPayment/BuyerProxyPayment.vue")
    },
    {
        path: '/createCustomer',
        name: 'createCustomer',
        title: '添加客户',
        component: () => import("@/views/BuyerProxyPayment/createCustomer.vue")
    },
    {
        path: '/createCustomerSuc',
        name: 'createCustomerSuc',
        title: '添加客户成功',
        component: () => import("@/views/BuyerProxyPayment/createCustomerSuc.vue")
    },
    {
        path: '/takeOrderType',
        name: 'takeOrderType',
        title: '下单模式',
        component: () => import("@/views/BuyerProxyPayment/takeOrderType.vue")
    }
]

// 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes
})

// 添加路由守卫，动态设置页面标题
router.beforeEach((to, from, next) => {
    // 设置页面标题为当前路由的name
    document.title = to.name || '食养集'
    next()
})

export default router